import { render } from "./label.vue?vue&type=template&id=cdeba36a&scoped=true"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"

import "./label.vue?vue&type=style&index=0&id=cdeba36a&scoped=true&lang=scss"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdeba36a"]])

export default __exports__